/* eslint-disable no-unused-expressions */
/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, createContext } from "react";
import { observer } from "mobx-react";
import { useHistory } from "react-router-dom";
import SequenceContactsNav from "./SequenceContactsNav";
import makeApi, { URLS } from "Utils/apiURL";
import Utils from "Utils/utils";
import DateUtils from "Utils/DateUtils";
import userDetail from "Stores/userDetail";
import SequenceUtils from "Utils/SequenceUtils";
import InboxUtils from "Utils/InboxUtils";
import { sequenceRenderState } from "./../SequencePage/sequenceProperties";
import EmailInsightComponent from "Components/common/EmailInsights";
import { sequenceContactData } from "Stores/sequence/Contact";
import { toasterState } from "Components/common/toaster";
import {
  MP_EVENT,
  SUPPORT_URL_RESUMING_FAILED_CONTACTS
} from "Static/constant";
import ootoCalendarIcon from "Assets/png/ootoCalendar.png";
import PaginationComponent from "Components/common/PaginationComponent";
import CheckBox from "Components/common/CheckBox";
import { checkTeamSubscriptionActive } from "Utils/commonAPI";
import ContactSelectedTagList from "Components/common/ContactSelectedTagList";
import LinearProgressLoader from "Components/LinearProgressLoader";
import ExportBtn from "Components/common/ExportBtn";
import AddToSequenceButton from "Components/common/AddToSequenceButton";
import NoContactImg from "Assets/png/contact.png";
import AddContactDropDown from "Components/common/AddContactDropDown";
import ContactSelectedCount from "Components/common/ContactSelectedCount";
import ContactMoreOption from "Components/common/ContactFilter/ContactMoreOption";
import { deselectCheckedPopupState } from "Components/common/DeselectCheckedPopup";
import PageLimit from "Components/common/PageLimit";
import { contactSelectedTagListStore } from "Components/common/ContactSelectedTagList";
import CustomTooltip from "Components/common/CustomTooltip";
import StatusCellTooltip from "./StatusCellTooltip";
import { approvalPopupState } from "../DeepResearchApproval/ApprovalPopupState";
import AwaitingApprovalBanner from "../DeepResearchApproval/AwaitingApprovalBanner";
import SequenceMoreOption from "./SequenceMoreOption";
import FeatureDemoVideo from "Components/common/FeatureDemoVideo";
import { confirmationPopupState } from "Components/common/confirmationPopup";
import { editContactPopupState } from "../../contacts/EditContactPopup";
import { emailPreviewContentPopupState } from "Components/PreviewPopup/EmailPreviewContentPopup";
import FilterByStep from "./FilterByStep";
import StepsList from "./StepsList";
import PaywallUtils from "Utils/PaywallUtils";
import SearchByContactKeyword from "../../contacts/SearchByContactKeyword";
import { ReactComponent as FilterIcon } from "Assets/svg/filter.svg";
import { ReactComponent as RepliedIcon } from "Assets/svg/repliedIconSeq.svg";
import SequenceContactFilter from "./SequenceContactFilter/index";
import sequenceContactStoreData from "./SequenceContactFilter/sequenceContactStore";
import { tagsStoreData } from "Stores/TagsData";
import { SEQ_CONTACT_TAB_FILTER_OBJECT } from "Model/model";
import { sequenceStoreData } from "Stores/sequenceData";
import { ReactComponent as WarningField } from "Assets/svg/autoReplyWarning.svg";
import { ReactComponent as LinkedInIcon } from "../../settings/ConnectedAccounts/LinkedInAccounts/svg/linkedIn.svg";
import { linkedInReplyPopupState } from "Components/PreviewPopup/LinkedInReplyContentPopup";
import { waReplyPopupState } from "Components/PreviewPopup/WaReplyContentPopup";
import { pullContactState } from "Pages/ImportContactsFromLinkedIn/store";
import { importProgressJobs } from "../ProgressJobs/ImportProgressJobsStore";
import tableConfigStore from "Stores/TableConfig";
import { settingsStoreData } from "Stores/settingsData";
import CustomDragAndDrop from "Components/common/CustomDragAndDrop";
import ContactLoader from "Pages/Dashboard/contacts/ContactLoader";

const SeqContactTeamDataFilterContext = createContext({});

const defaultFieldsForLoader = [
  {
    name: "email",
    displayName: "Email address",
    enabled: true
  },
  {
    name: "name",
    displayName: "Name",
    enabled: true
  },
  {
    name: "insights",
    displayName: "Email Insights",
    enabled: true
  },
  {
    name: "nextEmailDate",
    displayName: "Next step",
    enabled: true
  },
  {
    name: "lastContacted",
    displayName: "Last Contacted",
    enabled: true
  },
  {
    name: "jobTitle",
    displayName: "Title",
    enabled: true
  },
  {
    name: "stage",
    displayName: "Stage",
    enabled: true
  },
  {
    name: "company",
    displayName: "Company",
    enabled: true
  },
  {
    name: "domain",
    displayName: "Website",
    enabled: true
  },
  {
    name: "mobilePhone",
    displayName: "Mobile Number",
    enabled: true
  },
  {
    name: "linkedinId",
    displayName: "LinkedIn URL",
    enabled: true
  },
  {
    name: "website",
    displayName: "Personal Website",
    enabled: true
  },
  {
    name: "country",
    displayName: "Country",
    enabled: true
  },
  {
    name: "companyNumber",
    displayName: "HQ number",
    enabled: true
  },
  {
    name: "phone",
    displayName: "Phone number",
    enabled: true
  },
  {
    name: "otherPhone",
    displayName: "Other number",
    enabled: true
  },
  {
    name: "tags",
    displayName: "Tags",
    enabled: true
  },
  {
    name: "customField1",
    displayName: "Custom field 1",
    enabled: true
  },
  {
    name: "customField2",
    displayName: "Custom field 2",
    enabled: true
  },
  {
    name: "customField3",
    displayName: "Custom field 3",
    enabled: true
  }
];

const SequenceContacts = (props = {}) => {
  const {
    sequence = {},
    seqId = "",
    exportAllContactSelected = false,
    contactsData = {},
    folderId = "",
    isSharedSequenceWithUser = false,
    showContactOwner = false,
    loader = false,
    totalPages = 0,
    totalContacts = 0,
    selectedEntityCount = 0,
    contactIds = [],
    exportEnabled = false,
    activeTab = "",
    allContactSelected = "",
    contactLimit = 10,
    setContactLimit = 10,
    updateSequenceContacts = false,
    allowContactsUpload = false,
    sequenceToggleBtn = true,
    isFromStepBadgeNavigation = false,
    setExportAllContactSelected = () => {},
    setExportData = () => {},
    setScheduledIdData = () => {},
    setContactsData = () => {},
    setLoader = () => {},
    setCurrentStage = () => {},
    selectedContactCard = () => {},
    exportCbk = () => {},
    retryContactCbk = () => {},
    addToSequenceAction = () => {},
    bulkRemoveSeqContactCbk = () => {},
    bulkReactivateSeqContactCbk = () => {},
    bulkResumeSeqContactCbk = () => {},
    bulkPauseSeqContactCbk = () => {},
    addTagsCbk = () => {},
    removeTagsCbk = () => {},
    resetContactCbk = () => {},
    selectAllCbk = () => {},
    setActiveTab = () => {},
    addSingleContact = () => {},
    addBulkContact = () => {},
    setAllContactSelected = () => {},
    searchKeyword = "",
    setSearchKeyword = () => {},
    resetToSelectedCheckboxCbk = () => {},
    setUpdateSequenceContacts = () => {},
    setUpdatedContact = () => {},
    setFromStepBadgeNavigation = () => {},
    getTotalCountForEachFilter = () => {},
    importFromContactsListClick = null
  } = props || {};

  const allDataForSteps = {
    all: true,
    count: 0,
    selected: false,
    order: "all",
    stepMetrics: []
  };

  const { planName = "", inFreePlan = false } =
    userDetail.userFeatureFlag || {};

  const history = useHistory();

  const [isContactUploading, setContactUploading] = useState(false);
  const [isSnContactUploading, setSnContactUploading] = useState(false);
  const [isEmailClose, setEmailClose] = useState(false);
  const [showStepsList, setShowStepsList] = useState(isFromStepBadgeNavigation);
  const [showContactFilter, setShowContactFilter] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const [filterArr, setFilterArr] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState(false);
  const [teamFilterDropDownData, setTeamFilterDropDownData] = useState([]);
  const [teamCount, setTeamCount] = useState(0);
  const [data, setData] = useState({
    ...(sequenceContactStoreData?.contactFilterObject || {})
  });
  const [activeFilter, setActiveFilter] = useState(false);
  const [metricData, setMetricData] = useState([{}]);
  const [analyticStepLoader, setAnalyticStepLoader] = useState(true);
  const [outofOotoTooltip, setOutofOotoTooltip] = useState(false);
  const [showExportTypeDropdown, setShowExportTypeDropdown] = useState(false);
  const [totalActiveBulkJobs, setTotalActiveBulkJobs] = useState(0);
  const [totalInProgressJobs, setTotalInprogressJobs] = useState(0);
  const [totalProgressPercent, setTotalProgressPercent] = useState(0);
  const [headers, setHeaders] = useState([]);

  let defaultSelectAllTeamMemberObject = [
    {
      id: "selectAll",
      value: "Select All",
      show: true
    }
  ];

  const constructTeamMemberList = (teamFilterDataResponse = []) => {
    let temp = [...teamFilterDataResponse];
    const arrList = [...defaultSelectAllTeamMemberObject];
    temp.forEach(item => {
      const { group = {}, members = [] } = item || {};
      if (members?.length > 0) {
        arrList.push({
          name: group?.name,
          id: group?.id,
          value: group?.name,
          show: true,
          showSubmenu: true,
          submenu: members?.map(item => {
            const { memberId = "" } = item || {};
            return {
              name: Utils.getFullNameFromUserInfo(item),
              value: Utils.getFullNameFromUserInfo(item),
              show: true,
              id: memberId
            };
          })
        });
      }
    });
    return arrList;
  };

  const constructTeamDataInFilter = async () => {
    const config = {
      url: URLS.getTeamData,
      method: "GET"
    };
    let response = await makeApi(config);
    if (response?.status === 200 && response?.data?.groups) {
      setTeamFilterDropDownData(
        constructTeamMemberList(response?.data?.groups)
      );
    } else {
      setTeamFilterDropDownData([]);
    }
  };

  const getPayloadFilterStatus = (tab = "", payload = {}) => {
    if (!sequenceContactStoreData?.isOverviewToContactsPage) {
      const filterPayloadValue =
        sequenceContactStoreData?.filterPayload?.filters || {};
      let tempFilter = {};
      payload.filters = {
        ...filterPayloadValue
      };
      if (Utils.isEligibleContactFilter(tab)) {
        payload.filters = {
          ...filterPayloadValue,
          statuses: SequenceUtils.getSelectedTab(tab)
        };
        tempFilter = {
          statuses: SequenceUtils.getSelectedTab(tab)
        };
      } else if (tab?.toLowerCase() !== "total") {
        let fields = [
          {
            fieldName: SEQ_CONTACT_TAB_FILTER_OBJECT[tab?.toLowerCase()] || tab,
            operator: "GREATER_THAN",
            value: 0
          }
        ];
        tempFilter = {
          fields
        };
        if (filterPayloadValue?.fields?.length > 0) {
          fields = filterPayloadValue.fields.concat(fields);
        }
        payload.filters = { ...payload.fields, fields };
      }
      const { all = false, idArr = [] } =
        sequenceRenderState?.contactOwner || {};
      if (idArr?.length > 0) {
        payload.filters.memberIds = idArr;
      } else {
        payload.filters.all = all;
      }
      sequenceContactStoreData.setOverallPayload(payload);
      sequenceContactStoreData.setTopFilter(tempFilter);
      return payload;
    }
    return {};
  };

  const getTableContacts = (tab = "Total", tagIds = [], loaderFlag = true) => {
    if (!sequenceContactStoreData?.isOverviewToContactsPage) {
      loaderFlag && setLoader(true);
      const { all = false, idArr = [] } =
        sequenceRenderState?.contactOwner || {};
      setExportData([]);
      setScheduledIdData([]);
      let payload = {
        campaignId: seqId,
        limit: contactLimit,
        filters: { searchTerm: searchKeyword }
      };
      payload = getPayloadFilterStatus(tab, payload, tagIds);
      if (idArr?.length > 0) {
        payload.filters.memberIds = idArr;
      } else {
        payload.filters.all = all;
      }
      payload.filters.stepMetrics = sequenceRenderState?.filterByStep
        ? [sequenceRenderState?.filterByStep]
        : [];
      sequenceContactData.getSeqContacts(payload);
    }
  };

  const changeStatusClicked = (seqId = "") => {
    let contactList = contactsData.individualSequenceAnalyticsList;
    const updatedContactList = contactList.map(e => {
      if (e) {
        if (e.sequenceId === seqId) {
          e.showStatusDropDown = !e.showStatusDropDown;
        } else {
          e.showStatusDropDown = false;
        }
      }
      return e;
    });
    contactsData.individualSequenceAnalyticsList = updatedContactList;
    setContactsData(contactsData);
  };

  const hasContacts = () => {
    return (
      contactsData?.individualSequenceAnalyticsList &&
      contactsData?.totalContacts > 0
    );
  };

  const hideChangeStatusDropDOwnMenu = id => {
    let contactList = contactsData?.individualSequenceAnalyticsList;
    const updatedContactList = contactList.map(item => {
      item.sequenceId === id && (item.showStatusDropDown = false);
      return item;
    });
    contactsData.individualSequenceAnalyticsList = updatedContactList;
    setContactsData(contactsData);
  };

  const pauseContactSequence = async (id, contact) => {
    hideChangeStatusDropDOwnMenu(id);
    if (await checkTeamSubscriptionActive()) {
      toasterState.setToastMsg("Processing...", "info");
      let targetUrl = URLS.pauseContactSeq || "";
      if (targetUrl) {
        targetUrl = targetUrl?.replace("<<seqId>>", id);
        const config = {
          url: targetUrl,
          method: "PUT"
        };
        let res = await makeApi(config);
        if (res?.data) {
          const { requestStatus = "" } = res?.data || {};
          if (requestStatus) {
            setUpdateSequenceContacts(true);
            const status = "PAUSED";
            handleSequenceStatusUpdate(id, status);
            toasterState.setToastMsg(
              "Contact has been paused successfully",
              "success"
            );
          } else {
            handleSequenceStatusUpdate(id);
            toasterState.setToastMsg(
              "Failed to pause the contact from the sequence",
              "failure"
            );
          }
        } else {
          Utils.showApiFailureResponse(res);
        }
      }
    }
  };

  const handleSequenceStatusUpdate = (id, status) => {
    let contactList = contactsData.individualSequenceAnalyticsList;
    const updatedContactList = contactList.map(e => {
      if (e && e.sequenceId === id) {
        if (status) e.status = status;
        e.showStatusDropDown = false;
      }
      return e;
    });
    contactsData.individualSequenceAnalyticsList = updatedContactList;
    setContactsData(contactsData);
    sequenceContactData.getSeqAnalyticsTab(
      seqId,
      sequenceContactStoreData?.filterPayload?.filters || {}
    );
    filterContactByStatus(sequenceRenderState.currentStage);
  };

  const resumeContactCbk = async id => {
    toasterState.setToastMsg("Processing...", "info");
    let targetUrl = URLS.resumeContactSeq ? URLS.resumeContactSeq : "";
    if (targetUrl) {
      targetUrl = targetUrl.replace("<<seqId>>", id);
      const config = {
        url: targetUrl,
        method: "PUT"
      };
      let res = await makeApi(config);
      if (res?.data) {
        const { inboxError = {}, respCode = "" } = res?.data || {};
        if (
          +respCode === 200 &&
          (!inboxError || (inboxError && !Object.keys(inboxError)?.length))
        ) {
          setUpdateSequenceContacts(true);
          const status = "ACTIVE";
          handleSequenceStatusUpdate(id, status);
          toasterState.setToastMsg(
            "Contact has been activated successfully",
            "success"
          );
        } else if (+respCode === 407) {
          toasterState.setToastMsg(
            "Failed to resume contact. Contact's scheduled inbox is unavailable.",
            "failure"
          );
        } else if (+respCode === 403) {
          toasterState.setToastMsg(
            "Failed to resume contact. You don't have access to this contact.",
            "failure"
          );
        } else if (inboxError && Object.keys(inboxError)?.length) {
          const email = Object.keys(inboxError)?.[0];
          confirmationPopupState.setPopupValues({
            content: `Failed to activate the contact as <a class="emailLink" href="mailto:${email}">${email}</a> is not connected to this sequence.`,
            actionBtnText: "Ok",
            callback: () => {
              confirmationPopupState.setShowPopup(false);
              history && history.push("#settings");
            },
            needCancelBtn: false
          });
          confirmationPopupState.setShowPopup(true);
        } else {
          toasterState.setToastMsg(
            "Failed to resume contact from the sequence",
            "failure"
          );
        }
      } else {
        Utils.showApiFailureResponse(res);
      }
    }
  };

  const resumeOOOContactCbk = async id => {
    toasterState.setToastMsg("Processing...", "info");
    let targetUrl = URLS.resumeOOOContactSeq || "";
    if (targetUrl) {
      targetUrl = targetUrl.replace("<<seqId>>", id);
      const config = {
        url: targetUrl,
        method: "POST"
      };
      let res = await makeApi(config);
      if (res?.data) {
        if (res?.data?.status) {
          setUpdateSequenceContacts(true);
          const status = "ACTIVE";
          handleSequenceStatusUpdate(id, status);
          toasterState.setToastMsg(
            "Contact has been activated successfully",
            "success"
          );
        } else {
          toasterState.setToastMsg(
            "Failed to resume contact from the sequence",
            "failure"
          );
        }
      } else {
        Utils.showApiFailureResponse(res);
      }
    }
  };

  const OOOPopupContent = props => {
    const { contact = {} } = props;
    return (
      <>
        <div>Are you sure you want to resume this PAUSED (ooo) contact?</div>
        <div style={{ fontSize: "13px", marginTop: "4px" }}>
          {`This contact will resume automatically on ${getFormattedDate(
            contact?.rescheduleDate
          )}. However, clicking on 'Yes' will resume the contact immediately.`}
        </div>
      </>
    );
  };

  const resumeContactSequence = async (
    id,
    status,
    contact = {},
    sequence = {}
  ) => {
    hideChangeStatusDropDOwnMenu(id);
    if (await checkTeamSubscriptionActive()) {
      if (allowContactsUpload) {
        if (
          SequenceUtils.checkEmailSteps(sequence) &&
          !Utils.isAccountConnected()
        ) {
          Utils.showAddAccountPopup(
            props,
            "Please connect your email account before resuming the sequences"
          );
        } else {
          if (status === "PAUSED_OOTO") {
            confirmationPopupState.setPopupValues({
              content: <OOOPopupContent contact={contact} />,
              actionBtnText: "Yes",
              cancelBtnText: "Cancel",
              cancelCbk: () => confirmationPopupState.setShowPopup(false),
              callback: () => resumeOOOContactCbk(id),
              dynamicDom: true
            });
            confirmationPopupState.setShowPopup(true);
          } else {
            resumeContactCbk(id);
          }
        }
      } else {
        PaywallUtils.upgradeUtilsFunction(
          "pauseResumeSequence",
          false,
          planName,
          inFreePlan
        );
      }
    }
  };

  const filterContactByStatus = (value = "") => {
    setLoader(true);
    resetValueToInitial();
    setCurrentStage(value);
    getTableContacts(value);
  };

  const paginate = (pageNoObj, limit) => {
    if (!loader) {
      resetValueToInitial();
      let payload = {
        campaignId: seqId
      };
      payload.pageNo = pageNoObj.selected ? pageNoObj.selected + 1 : 1;
      payload.limit = contactLimit;
      payload = getPayloadFilterStatus(
        sequenceRenderState?.currentStage || "",
        payload
      );
      payload.filters = {
        ...payload?.filters,
        ...sequenceContactStoreData?.filterPayload?.filters
      };
      const { all, idArr } = sequenceRenderState.contactOwner;
      if (idArr.length > 0) {
        payload.filters.memberIds = idArr;
      } else {
        payload.filters.all = all;
      }
      payload.filters.stepMetrics = sequenceRenderState?.filterByStep
        ? [sequenceRenderState?.filterByStep]
        : [];
      setLoader(true);
      sequenceContactData.getSeqContacts(payload);
    }
  };

  const addStatusColor = status => {
    switch (status) {
      case "ACTIVE":
        return "color-active";
      case "PAUSED":
      case "PAUSED_OOTO":
        return "color-paused";
      case "COMPLETED":
        return "color-complete";
      case "MEETING_BOOKED":
        return "color-meeting-booked";
      case "REPLIED":
        return "color-complete";
      case "SUSPENDED":
        return "color-hold";
      case "OPTED_OUT":
        return "color-hold";
      case "PENDING":
        return "color-pending";
      case "AWAITING_APPROVAL":
        return "color-awaiting-approval";
      case "FAILED":
        return "color-failed";
      default:
        return "color-default";
    }
  };

  const changeStatusIcon = status => {
    switch (status) {
      case "ACTIVE":
        return "access_time";
      case "PAUSED":
      case "PAUSED_OOTO":
        return "pause_circle_outline";
      case "COMPLETED":
        return "check_circle";
      case "MEETING_BOOKED":
        return "event";
      case "REPLIED":
        return "reply";
      case "SUSPENDED":
        return "schedule";
      case "OPTED_OUT":
        return "block";
      case "BOUNCED":
        return "call_missed_outgoing";
      case "PENDING":
        return "hourglass_top";
      case "AWAITING_APPROVAL":
        return "hourglass_top";
      case "FAILED":
        return "error_outline";
      default:
        return "warning";
    }
  };

  const getUploadContact = value => {
    setContactUploading(value);
  };

  const getFormattedDate = date => {
    return Utils.getFormattedDateToDisplay(date);
  };

  const canShowStatusDropDown = (status = "") => {
    if (["PAUSED", "PAUSED_OOTO"]?.includes(status) && !sequenceToggleBtn) {
      return false;
    } else {
      return ["ACTIVE", "PAUSED", "PAUSED_OOTO"].includes(status);
    }
  };

  const StatuSection = (props = {}) => {
    const { contact = {}, viewEmailReply = () => {} } = props || {};
    const {
      status = "",
      code = "",
      missingFields = [],
      errorCode = "",
      replyDetectionSource = ""
    } = contact || {};

    const { multipleInboxEnabled = false } = userDetail?.userFeatureFlag || {};

    const getDropdownTopValue = seqId => {
      if (seqId) {
        const targetDom = document.getElementById(seqId);
        const parentDom = document.querySelector(".contactContent");
        const targetOffset = targetDom ? targetDom.offsetTop + 16 : 0; // 16 top is padding and border of contact card
        if (
          targetOffset &&
          parentDom &&
          targetOffset > parentDom.offsetHeight - 60
        ) {
          return "-48px";
        }
      }
    };

    const extractPhoneNumbersFromContact = contact => {
      if (contact?.phone?.length) {
        contact.phone = contact.phone[0];
      }
      if (contact?.mobilePhone?.length) {
        contact.mobilePhone = contact.mobilePhone[0];
      }
      if (contact?.otherPhone?.length) {
        contact.otherPhone = contact.otherPhone[0];
      }
      return contact;
    };

    const handleUpdateContactSuccess = (contact = {}) => {
      let contactList = contactsData.individualSequenceAnalyticsList;
      const updatedContactList = contactList.map(item => {
        if (item?.emailAddress === contact?.email) {
          item.name = `${contact?.firstName} ${contact?.lastName}`;
        }
        return item;
      });
      contactsData.individualSequenceAnalyticsList = updatedContactList;
      setContactsData(contactsData);
    };

    const handleContactClick = async () => {
      const { contactId = "", id = "" } = contact || {};
      let tempId = id || contactId;
      if (tempId) {
        try {
          const url = URLS.getContactDetail.replace("<<contactId>>", tempId);
          const config = {
            url
          };
          let res = await makeApi(config);
          if (res?.data?.contact?.id) {
            let updatedItem = extractPhoneNumbersFromContact(
              res?.data?.contact
            );
            editContactPopupState.setContact(updatedItem);
            editContactPopupState.setShowPopup(true);
            editContactPopupState.setCallback(handleUpdateContactSuccess);
          } else {
            setUpdatedContact([]);
          }
        } catch (error) {
          console.error("Getting contact card info error ", error);
        }
      }
    };

    const PopupContent = () => {
      return (
        <div className="invalidVariablesText">
          <div>
            The following mandatory fields are missing. Please update the
            contact with these fields and click <b>Retry</b>.{" "}
            <div className="LearnMoreBtnWrapper">
              <a
                href={SUPPORT_URL_RESUMING_FAILED_CONTACTS}
                target="_blank"
                rel="noopener noreferrer"
              >
                Learn more
              </a>
              <span className="material-icons-outlined launchIcon">launch</span>
            </div>
          </div>
          {SequenceUtils.tokensOrderList(missingFields)}
        </div>
      );
    };

    const getFailedToolTip = () => {
      confirmationPopupState.setPopupValues({
        content: <PopupContent />,
        actionBtnText: "Update",
        dynamicDom: true,
        callback: async () => {
          await handleContactClick();
          confirmationPopupState.setShowPopup(false);
        },
        loadingMsg: "Please wait..."
      });
      confirmationPopupState.setShowPopup(true);
    };

    const autoReplyErrorCode = {
      LEFT_THE_COMPANY: "Left the company",
      EMAIL_ADDRESS_CHANGED: "Email address changed",
      USER_INBOX_FULL: "User inbox is full"
    };

    const statusMsgObject = {
      ACTIVE: "ongoing",
      SUSPENDED: "on hold",
      OPTED_OUT: "opted out",
      IN_ACTIVE: "inactive",
      MEETING_BOOKED: "meeting booked",
      AUTO_REPLY: "auto reply",
      AWAITING_APPROVAL: "Awaiting approval",
      PAUSED_OOTO: (
        <div style={{ display: "flex", alignItems: "center" }}>
          <span style={{ marginRight: "4px" }}>paused </span>
          <span style={{ fontSize: "8px" }}>(OOO)</span>
        </div>
      )
    };

    const getStatusType = () => {
      return status?.toLowerCase() === "paused_ooto"
        ? "paused"
        : status?.toLowerCase();
    };

    const handleStatusClick = () => {
      if (["active", "paused", "paused_ooto"].includes(status?.toLowerCase())) {
        changeStatusClicked(contact?.sequenceId);
      }
    };

    const handleRepliedStatusClick = () => {
      if (status?.toLowerCase() === "replied") {
        if (replyDetectionSource?.toLowerCase() === "linkedin") {
          viewLinkedInReply(contact, status, replyDetectionSource);
        } else if (replyDetectionSource?.toLowerCase() === "whatsapp") {
          viewWaReply(contact);
        } else {
          viewEmailReply(contact, status);
        }
      }
    };

    return (
      <>
        <div
          className={`statusContainer ${getStatusType()} ${
            replyDetectionSource?.toLowerCase() === "linkedin"
              ? "linkedinReply"
              : ""
          }`}
          onClick={handleRepliedStatusClick}
          onMouseEnter={handleStatusClick}
          onMouseLeave={() =>
            hideChangeStatusDropDOwnMenu(contact?.sequenceId || "")
          }
        >
          {(() => {
            const nameSpan = (
              <span
                className={`status-name ${status.toLowerCase()} ${addStatusColor(
                  status
                )} ${status === "FAILED" ? "cursor" : ""} ${
                  status === "PAUSED_OOTO" ? "paused_ooto" : ""
                }`}
              >
                {status?.toUpperCase() === "WAITING" ||
                (replyDetectionSource?.toLowerCase() === "linkedin" &&
                status?.toLowerCase() !== "opted_out") ? (
                  <LinkedInIcon />
                ) : status?.toLowerCase() === "auto_reply" ? (
                  <span className="autoReplyStatusIcon">
                    <WarningField />
                  </span>
                ) : (
                  <i className="material-icons-outlined">
                    {changeStatusIcon(status)}
                  </i>
                )}
                &nbsp;
                {status?.toUpperCase() === "WAITING"
                  ? "Waiting"
                  : status?.toLowerCase() === "replied"
                  ? replyDetectionSource?.toLowerCase() === "linkedin"
                    ? "View Reply (LinkedIn)"
                    : replyDetectionSource?.toLowerCase() === "whatsapp"
                    ? "View Reply (WhatsApp)"
                    : "View Reply (Email)"
                  : statusMsgObject?.[status] || status?.toLowerCase()}
              </span>
            );
            // Build interactive tooltip body for FAILED states. Returns JSX
            // (string or rich) when the code maps to a known failure reason,
            // otherwise null. Routes through StatusCellTooltip below so the
            // tooltip portals out of the table's overflow:scroll ancestor and
            // wraps to multiple lines without clipping.
            const buildFailedTooltipContent = () => {
              if (status?.toUpperCase() !== "FAILED") return null;
              const c = (code || "").toLowerCase();
              if (c === "missing_token" || !code) {
                return (
                  <>
                    Missing contact Variable.{" "}
                    {!missingFields || !missingFields?.length > 0 ? (
                      <a
                        href={SUPPORT_URL_RESUMING_FAILED_CONTACTS}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Learn more.
                      </a>
                    ) : (
                      <span className="linkHighLight" onClick={getFailedToolTip}>
                        Show more.
                      </span>
                    )}
                  </>
                );
              }
              if (c === "inbox_not_found") {
                const link = multipleInboxEnabled ? "#settings" : "/settings/account";
                return (
                  <>
                    Inbox unavailable. Please connect inbox to resume.{" "}
                    <a href={link} className="redirectLink">Connect.</a>
                  </>
                );
              }
              if (c === "contact_email_not_found") return "Contact's email address is not available.";
              if (c === "li_error") return "Unknown error. Please retry.";
              if (c === "li_reconnect_required") return "LinkedIn connection expired. Reconnect your account to continue.";
              if (c === "li_verification_required") return "LinkedIn requires verification. Open LinkedIn, complete the verification, then retry.";
              if (c === "li_account_restricted") return "LinkedIn restricted this account from performing this action.";
              if (c === "li_plan_required") return "This action requires a LinkedIn plan or feature not available on this account.";
              if (c === "li_invite_limit") return "LinkedIn invitation limit reached. Try again later.";
              if (c === "li_profile_cannot_be_contacted") return "This profile cannot be contacted through LinkedIn.";
              if (c === "li_inmail_not_available") return "InMail is not available for this profile or this account.";
              if (c === "li_message_needs_changes") return "LinkedIn rejected this message. Simplify the text or remove links, then retry.";
              if (c === "li_temporary_issue") return "Temporary LinkedIn issue. Retry in a few minutes.";
              if (c === "li_step_failed") return "LinkedIn couldn't complete this step. Please retry.";
              if (c === "do_not_contact") return "Contact's stage is 'do not contact'";
              if (c === "removed_from_do_not_contact") return "removed from do not contact";
              if (c === "email_send_limit") return "email send limit reached";
              if (c === "invalid_subject") return "Missing email subject line.";
              if (c === "contact_not_eligible") return "LinkedIn profile URL unavailable for this contact. Please update and try again.";
              // Deep Research failure codes — surfaced when the DR step bails
              // before research/content generation can complete. Tooltip
              // explains *why* so the rep can fix it without digging into
              // logs / DB.
              if (c === "deep_research_invalid_linkedin_url") return "Deep research couldn't run — LinkedIn URL is missing for this contact. Add it and retry.";
              if (c === "deep_research_insufficient_credit") return "Not enough credits for deep research. Top up your team's credits and retry.";
              if (c === "deep_research_api_failure") return "Deep research couldn't complete. Please retry — if it keeps failing, contact support.";
              return null;
            };

            if (
              status === "AWAITING_APPROVAL" &&
              Utils.isSequenceDRFeatureEnabled()
            ) {
              // Click on the badge opens the approval popup focused on this
              // contact. Affordance is the badge itself, since that's exactly
              // where the eye lands and where the tooltip already sits.
              const focusContactId = contact?.id || contact?.contactId || "";
              const openApproval = e => {
                e.stopPropagation();
                if (seqId) approvalPopupState.open(seqId, focusContactId);
              };
              const clickableSpan = (
                <span
                  className="awaitingApprovalClickable"
                  role="button"
                  tabIndex={0}
                  onClick={openApproval}
                  onKeyDown={e => {
                    if (e.key === "Enter" || e.key === " ") openApproval(e);
                  }}
                >
                  {nameSpan}
                </span>
              );
              return (
                <StatusCellTooltip text="Click to review messages for this contact — edit, approve, or reject.">
                  {clickableSpan}
                </StatusCellTooltip>
              );
            }
            const failedContent = buildFailedTooltipContent();
            if (failedContent) {
              return (
                <StatusCellTooltip
                  text={failedContent}
                  interactive
                  maxWidth={300}
                >
                  {nameSpan}
                </StatusCellTooltip>
              );
            }
            return nameSpan;
          })()}
          <span className="gapFiller"></span>
          {status?.toUpperCase() === "WAITING" && (
            <CustomTooltip
              text={`This contact is waiting for LinkedIn connection acceptance.`}
              {...props}
            />
          )}
          {status === "REPLIED" &&
            replyDetectionSource?.toLowerCase() !== "linkedin" && (
              <span className="replyVisibility">
                <RepliedIcon />
              </span>
            )}
          {status?.toUpperCase() === "FAILED" &&
            code?.toLowerCase() === "li_inbox_not_found" && (
              <CustomTooltip
                text={`LinkedIn account unavailable. Please connect account to resume.`}
                redirectText="Connect."
                className="inboxUnavailable"
                redirectLink={"/settings/account/linkedIn"}
                hasRedirectLink={true}
                {...props}
              />
            )}
          {status?.toUpperCase() === "FAILED" &&
            code?.toLowerCase() === "wa_no_phone_number" && (
              <CustomTooltip
                text={`Phone number unavailable for this contact. Please add a phone number and try again.`}
                {...props}
                className="contactNotEligible"
              />
            )}
          {status?.toUpperCase() === "FAILED" &&
            code?.toLowerCase() === "wa_account_not_found" && (
              <CustomTooltip
                text={`WhatsApp account unavailable. Please connect your account to resume.`}
                redirectText="Connect."
                className="inboxUnavailable"
                redirectLink={"/settings/account/email"}
                hasRedirectLink={true}
                {...props}
              />
            )}
          {status?.toUpperCase() === "FAILED" &&
            code?.toLowerCase() === "wa_account_disconnected" && (
              <CustomTooltip
                text={`WhatsApp account disconnected. Please reconnect your account to resume.`}
                redirectText="Connect."
                className="inboxUnavailable"
                redirectLink={"/settings/account/email"}
                hasRedirectLink={true}
                {...props}
              />
            )}
          {status?.toUpperCase() === "FAILED" &&
            code?.toLowerCase() === "wa_number_not_on_whatsapp" && (
              <CustomTooltip
                text={`This contact's phone number is not registered on WhatsApp.`}
                {...props}
                className="contactNotEligible"
              />
            )}
          {status?.toUpperCase() === "FAILED" &&
            code?.toLowerCase() === "wa_recipient_blocked" && (
              <CustomTooltip
                text={`This contact has blocked your WhatsApp account.`}
                {...props}
                className="contactNotEligible"
              />
            )}
          {status?.toUpperCase() === "FAILED" &&
            code?.toLowerCase() === "wa_rate_limit" && (
              <CustomTooltip
                text={`WhatsApp daily messaging limit reached. This contact will be retried.`}
                {...props}
                className="contactNotEligible"
              />
            )}
          {status?.toUpperCase() === "FAILED" &&
            code?.toLowerCase() === "wa_send_error" && (
              <CustomTooltip
                text={`Failed to send WhatsApp message. Please retry.`}
                {...props}
                className="contactNotEligible"
              />
            )}
          {status?.toLowerCase() === "auto_reply" && errorCode && (
            <CustomTooltip
              className="autoReplyTooltip"
              text={autoReplyErrorCode?.[errorCode] || "Uncategorised"}
              {...props}
            />
          )}
          {canShowStatusDropDown(status) && (
            <span className="change-status">
              <i className="material-icons icon-arrow">keyboard_arrow_down</i>
              {contact.showStatusDropDown && (
                <div>
                  <ul
                    className="status-dropdown"
                    style={{ top: getDropdownTopValue(contact.sequenceId) }}
                  >
                    {contact.status === "ACTIVE" && (
                      <li
                        key="pause"
                        className="status-dropdown-item color-paused"
                        onClick={e =>
                          pauseContactSequence(
                            contact?.sequenceId || "",
                            contact
                          )
                        }
                      >
                        <i className="material-icons-outlined">
                          pause_circle_outline
                        </i>
                        <span>Pause</span>
                      </li>
                    )}
                    {["PAUSED", "PAUSED_OOTO"]?.includes(status) && (
                      <li
                        key="resume"
                        className="status-dropdown-item color-active"
                        onClick={e => {
                          resumeContactSequence(
                            contact.sequenceId,
                            status,
                            contact,
                            sequence
                          );
                        }}
                      >
                        <i className="material-icons-outlined">play_arrow</i>
                        <span>Resume</span>
                      </li>
                    )}
                  </ul>
                </div>
              )}
            </span>
          )}{" "}
        </div>
      </>
    );
  };

  const isEligibleToShowNextStep = status => {
    return (
      status &&
      ![
        "COMPLETED",
        "BOUNCED",
        "REPLIED",
        "OPTED_OUT",
        "PENDING",
        "FAILED"
      ].includes(status)
    );
  };

  const markSelectedContact = (value, contactId) => {
    if (allContactSelected) {
      deselectCheckedPopupState.setPopupValues({
        callback: resetToSelectedCheckboxCbk
      });
      deselectCheckedPopupState.setPopup(true);
    } else {
      if (contactId === "all") {
        setExportAllContactSelected(value);
        toggleSelectAllTableContact();
        constructExportData("all");
        !value && resetValueToInitial();
      } else {
        setExportAllContactSelected(false);
        toggleSelectContactById(contactId);
        constructExportData();
      }
    }
  };

  const toggleSelectContactById = contactId => {
    const contactList =
      contactsData && contactsData.individualSequenceAnalyticsList;
    if (contactId) {
      contactList &&
        contactList.map(value => {
          value?.contactId === contactId &&
            (value.isSelected = !value.isSelected);
        });
      updateContactsData(contactList);
    }
  };

  const toggleSelectAllTableContact = () => {
    const contactList =
      contactsData && contactsData.individualSequenceAnalyticsList;
    contactList &&
      contactList.map(value => {
        if (value && value.contactId) {
          if (exportAllContactSelected) {
            value.isSelected = false;
            setExportAllContactSelected(false);
          } else {
            value.isSelected = true;
          }
        }
      });
    updateContactsData(contactList);
  };

  const constructExportData = flag => {
    const tempArr = [];
    const scheduledId = [];
    const contactList =
      contactsData && contactsData.individualSequenceAnalyticsList;
    if (flag === "all") {
      contactList &&
        contactList.map(value => {
          if (value?.contactId) {
            tempArr.push(value?.contactId);
            scheduledId.push(value?.sequenceId);
          }
        });
    } else {
      contactList &&
        contactList.map(value => {
          if (value?.contactId && value?.isSelected) {
            tempArr.push(value?.contactId);
            scheduledId.push(value?.sequenceId);
          }
        });
    }
    setExportData(tempArr);
    setScheduledIdData(scheduledId);
  };

  const updateContactsData = contactList => {
    if (contactList) {
      const dupContactsData = { ...contactsData };
      dupContactsData.individualSequenceAnalyticsList = contactList;
      setContactsData(dupContactsData);
    }
  };

  const slideContactCard = (contact = {}) => {
    selectedContactCard(contact);
  };

  const resetValueToInitial = () => {
    setExportAllContactSelected(false);
    setExportData([]);
    setScheduledIdData([]);
    clearSearchInput();
    clearSearchPerformingState();
  };

  const filterAnalyticsByTags = (
    contactTags = [],
    searchKeyword = null,
    payload = {}
  ) => {
    if (contactTags?.length) {
      clearSearchPerformingState();
      sequenceContactData.getSeqAnalyticsTab(seqId, payload);
    } else if (searchKeyword) {
      sequenceContactData.getSeqAnalyticsTab(seqId, payload, searchKeyword);
    } else {
      clearSearchPerformingState();
      let tempPayload = sequenceContactStoreData?.filterPayload?.filters || {};
      tempPayload.stepMetrics = sequenceRenderState?.filterByStep
        ? [sequenceRenderState?.filterByStep]
        : [];
      sequenceContactData.getSeqAnalyticsTab(seqId, tempPayload);
    }
  };

  const showDemoVideoCard = () => {
    return (
      !(
        contactsData &&
        Object.keys(contactsData).length &&
        contactsData?.totalContacts > 0
      ) && activeTab === "total"
    );
  };

  const hasContactChecked = () => {
    return selectedEntityCount || contactIds?.length ? true : false;
  };

  const searchContact = e => {
    Utils.preventDefaultFn(e);
    const { all = false, idArr = [] } = sequenceRenderState?.contactOwner || {};
    const payload = {
      campaignId: seqId,
      limit: contactLimit,
      pageNo: contactsData?.currentPage,
      filters: {
        ...sequenceContactStoreData?.filterPayload?.filters,
        searchTerm: searchKeyword
      }
    };
    if (idArr?.length > 0) {
      payload.filters.memberIds = idArr;
    } else {
      payload.filters.all = all;
    }
    payload.filters.stepMetrics = sequenceRenderState?.filterByStep
      ? [sequenceRenderState?.filterByStep]
      : [];
    setShowStepsList(false);
    sequenceRenderState.setPerformingSearch(true);
    contactSelectedTagListStore.setEmptyTagList();
    sequenceRenderState.setCurrentStage("Total");
    sequenceRenderState.setFilteredTags([]);
    setLoader(true);
    filterAnalyticsByTags(null, searchKeyword, payload?.filters);
    sequenceContactData.getSeqContacts(payload);
  };

  const handleSearchAction = event => {
    Utils.preventDefaultFn(event);
    setSearchKeyword(event.currentTarget.value);
    setEmailClose(!event.currentTarget.value.length < 1);
  };

  const submitSearchByEmailInput = e => {
    e?.preventDefault();
    e?.keyCode === 13 && searchContact(e);
  };

  const clearSearch = () => {
    clearSearchInput();
    if (sequenceRenderState.performingSearch) {
      setLoader(true);
      resetValueToInitial();
      filterAnalyticsByTags();
      getTableContacts(sequenceRenderState.currentStage);
    }
  };

  const clearSearchInput = () => {
    setSearchKeyword("");
    setEmailClose(false);
  };

  const clearSearchPerformingState = () => {
    sequenceRenderState.setPerformingSearch(false);
  };

  const reloadSequenceContactsPage = () => {
    getTableContacts(sequenceRenderState.currentStage);
    sequenceContactData.getSeqAnalyticsTab(
      seqId,
      sequenceContactStoreData?.filterPayload?.filters || {}
    );
  };

  const reloadAndResetContact = (completedContactIds = []) => {
    if (completedContactIds?.length) {
      reloadSequenceContactsPage();
    }
    resetContactCbk();
  };

  const getStageNextScheduledDateTooltip = (contactId = "", value = false) => {
    if (contactId) {
      let contactList = contactsData.individualSequenceAnalyticsList;
      const updatedContactList = contactList.map(item => {
        item?.contactId === contactId && (item.showNextDateTooltip = value);
        return item;
      });
      contactsData.individualSequenceAnalyticsList = updatedContactList;
      setContactsData(contactsData);
    }
  };

  const navigateToOutBox = (
    campaignId = "",
    nextTaskType = "",
    emailAddress
  ) => {
    if (["email"].includes(nextTaskType?.toLowerCase())) {
      let payload = {
        pageNo: 1,
        limit: 10,
        sortDirection: "ASC",
        sortParam: "SCHEDULED_DATE",
        filters: {
          all: false,
          memberIds: [userDetail?.userInfo?.memberId],
          campaignId: [campaignId],
          toAddress: [emailAddress]
        }
      };
      history.push("/inbox", { payload });
    }
  };

  const handleViewLinkedInContent = (resData = {}) => {
    const {
      messages = [],
      canViewLiReplies = false,
      ownerName = "",
      ownerProfileUrl = "",
      profilePictureUrl = "",
      liConnected = false
    } = resData || {};
    linkedInReplyPopupState.setShowPopup(true);
    linkedInReplyPopupState.setEditorLoading(false);
    linkedInReplyPopupState.setLiMessages(messages);
    linkedInReplyPopupState.setCanViewLiReplies(canViewLiReplies);
    linkedInReplyPopupState.setOwnerName(ownerName);
    linkedInReplyPopupState.setOwnerProfileUrl(ownerProfileUrl);
    linkedInReplyPopupState.setProfilePictureUrl(profilePictureUrl);
    linkedInReplyPopupState.setLiConnected(liConnected);
  };

  const handleViewEmailContent = (resData = {}, contactData = {}) => {
    const { emailInsights = {} } = contactData || {};
    const {
      id = "",
      touchPoint = {},
      sentDate = "",
      replyDate = "",
      campaignSequenceId: sequenceId = "",
      replyContent = "",
      sequenceName = "",
      order = "",
      taskType = "",
      oneOffEmail = "",
      timelineEmail = "",
      content = "",
      shortContent = "",
      recipientStatus = {},
      contactId = ""
    } = resData || {};
    const {
      fromAddress = "",
      toAddress = "",
      ccAddress = "",
      bccAddress = "",
      subject = "",
      repliedFromAddress = "",
      repliedToAddress = [],
      repliedCcAddress = []
    } = touchPoint || {};
    emailPreviewContentPopupState.setEditorLoading(false);
    emailPreviewContentPopupState.setShowReplyContent(true);
    emailPreviewContentPopupState.setPopupValues({
      taskId: id,
      eventType: "REPLIED",
      showViewReplyBtn: false,
      emailData: {
        from: repliedFromAddress
          ? { email: repliedFromAddress }
          : { email: fromAddress },
        to:
          Array.isArray(repliedToAddress) && repliedToAddress.length > 0
            ? InboxUtils.getEmailAddressList(repliedToAddress)
            : InboxUtils.getEmailAddressList(toAddress),
        cc:
          Array.isArray(repliedCcAddress) && repliedCcAddress.length > 0
            ? InboxUtils.getEmailAddressList(repliedCcAddress)
            : InboxUtils.getEmailAddressList(ccAddress),
        bcc: InboxUtils.getEmailAddressList(bccAddress),
        subject,
        content: replyContent || content || shortContent || ""
      },
      createTs: replyDate || sentDate,
      taskNotes: touchPoint?.notes,
      pageType: "sequenceContacts",
      sequenceId,
      replyContent,
      sequenceName,
      order,
      currentUserEmail: userDetail?.userInfo?.email,
      folderId,
      sequenceShareType: sequence?.shareType,
      email: "",
      taskType,
      autoEmail: taskType?.toLowerCase() === "email",
      group: "EMAIL",
      emailInsights,
      hideViewReplyBack: true,
      oneOffEmail,
      timelineEmail,
      isEnableReplyFrwd: true,
      pageType: "sequenceReply",
      contactId: contactId,
      recipientStatus: recipientStatus
    });
    emailPreviewContentPopupState.setShowPopup(true);
  };

  const viewWaReply = async (contact = {}) => {
    const { sequenceId = "" } = contact || {};
    if (!sequenceId) {
      toasterState.setToastMsg("Something went wrong", "failure");
      return;
    }
    waReplyPopupState.setShowPopup(true);
    waReplyPopupState.setEditorLoading(true);
    waReplyPopupState.setSsId(sequenceId);
    try {
      const config = {
        url: `${URLS.getWaReplyMessages}/${sequenceId}`,
        method: "GET"
      };
      const res = await makeApi(config);
      if (res?.data) {
        const chatId = res?.data?.chatId || "";
        waReplyPopupState.setChatId(chatId);
        waReplyPopupState.setMessages(res?.data?.messages || []);
      }
    } catch (err) {
      toasterState.setToastMsg("Failed to load WhatsApp conversation", "failure");
    } finally {
      waReplyPopupState.setEditorLoading(false);
    }
  };

  const viewLinkedInReply = async (
    contact = {},
    status = "",
    replyDetectionSource = ""
  ) => {
    linkedInReplyPopupState.setShowPopup(true);
    linkedInReplyPopupState.setEditorLoading(true);
    linkedInReplyPopupState.setContactSequenceId(contact?.sequenceId);
    if (
      status?.toLowerCase() === "replied" &&
      replyDetectionSource?.toLowerCase() === "linkedin"
    ) {
      const { contactId = "" } = contact || {};
      if (contactId) {
        const config = {
          url: `${URLS.getLinkedInReply}/${contactId}`,
          method: "GET"
        };
        let res = await makeApi(config);
        if (res?.data) {
          handleViewLinkedInContent(res?.data);
        }
      } else {
        toasterState.setToastMsg("something went wrong", "failure");
      }
    }
  };

  const viewEmailReply = async (contact = {}, status = "") => {
    if (status?.toLowerCase() === "replied") {
      emailPreviewContentPopupState.setShowPopup(true);
      emailPreviewContentPopupState.setEditorLoading(true);
      const { sequenceId = "", emailInsights = {} } = contact || {};
      if (sequenceId) {
        const config = {
          url: `${URLS?.getEmailContentViaScheduledId}${sequenceId}`,
          method: "GET"
        };
        let res = await makeApi(config);
        if (res?.data) {
          handleViewEmailContent(res?.data, { emailInsights });
        }
      } else {
        toasterState.setToastMsg("something went wrong", "failure");
      }
      emailPreviewContentPopupState.setEditorLoading(false);
    }
  };

  const resetOwnersList = (item = []) => {
    const { hasTeamMember } = userDetail?.userInfo || {};
    if (filterArr?.length && filterArr.includes("owners") && item?.length) {
      let tempData = [...item];
      tempData.map(item => (item.checked = false));
      userDetail.setUserInfo({
        ...userDetail.userInfo,
        hasTeamMember: tempData || false
      });
      return tempData;
    }
    return hasTeamMember;
  };

  const resetTagsList = (item = []) => {
    if (filterArr?.length && filterArr.includes("tags") && item?.length) {
      let tempData = [...item];
      tempData.map(item => (item.checked = false));
      tagsStoreData.setTagsData(tempData);
      return tempData;
    }
    return tagsStoreData.tagsData;
  };

  const addFilter = (currentStep = "all", data = []) => {
    const tempData = Utils.createObjWithoutRef(data);
    tempData.map((val = {}) => {
      const updatedCurrentStep = val?.currentStep || 0;
      val.selected = currentStep === updatedCurrentStep;
    });
    setMetricData(tempData);
    // Just clear the filter to get all the contacts if currentStep is "all"
    sequenceRenderState.setFilterByStep(
      currentStep === "all" ? null : currentStep
    );
  };

  const modifyInitialData = (response = {}) => {
    const { totalContacts = 0, stepMetrics = [] } = response || {};
    const isFilterSelected = sequenceRenderState?.filterByStep;
    if (isFilterSelected) {
      // applying the filter which already applied from step badge click from overview section
      allDataForSteps.count = totalContacts || 0;
      stepMetrics.unshift(allDataForSteps);
      addFilter(isFilterSelected, stepMetrics);
    } else {
      [...stepMetrics].map(val => {
        val.selected = false;
      });
      allDataForSteps.selected = true;
      allDataForSteps.count = totalContacts || 0;
      stepMetrics.unshift(allDataForSteps);
      setMetricData(stepMetrics);
    }
    setAnalyticStepLoader(false);
  };

  const getStepMetricData = async (currentStep = null, hasStep = false) => {
    const url = URLS.getStepLevelMetrics.replace("<<sequenceId>>", seqId);
    let data = {};
    // if (
    //   sequenceContactStoreData?.overallPayload?.filters &&
    //   Object.keys(sequenceContactStoreData?.overallPayload?.filters)?.length
    // ) {
    //   data = {
    //     ...sequenceContactStoreData?.overallPayload?.filters,
    //     ...(hasStep && {
    //       stepMetrics:
    //         [
    //           sequenceContactStoreData?.isOverviewToContactsPage
    //             ? sequenceContactStoreData?.overallPayload?.filters?.currentStep
    //             : currentStep
    //         ] || []
    //     })
    //   };
    // } else {
    //   data = sequenceContactStoreData?.overallPayload;
    // }
    const config = {
      url: url,
      method: "POST",
      data: {
        stepMetrics: []
      }
    };
    const response = await makeApi(config);
    modifyInitialData(response?.data);
  };

  const resetContactFilter = () => {
    setActiveFilter("");
    let tags = resetTagsList(data?.tags);
    let owners = resetOwnersList(data?.owners);
    const defaultFilterObject = {
      contactFields: [
        {
          fieldName: "",
          operator: "EQUALS",
          value: ""
        }
      ],
      metrics: [
        {
          fieldName: "",
          operator: "EQUALS",
          value: ""
        }
      ],
      dates: [
        {
          fieldName: "",
          isSet: false,
          isNotSet: false,
          fromDate: new Date(),
          toDate: null,
          operator: "BETWEEN"
        }
      ],
      sequences: [
        {
          fieldName: "",
          sequenceId: "",
          sequenceName: ""
        }
      ]
    };
    let tempObj = { ...defaultFilterObject, ...{ tags, owners } };
    setData(tempObj);
    sequenceContactStoreData.setContactFilterObject(tempObj);
    let filters =
      SequenceUtils.getActiveTabFilterPayload(
        sequenceRenderState?.currentStage || ""
      ) || {};
    const payload = {
      filters,
      pageNo: 1,
      limit: 10,
      campaignId: seqId
    };
    sequenceContactStoreData.setTopFilter(payload?.filters);
    sequenceContactStoreData.setFilterPayload(payload);
    sequenceContactStoreData.setOverallPayload(payload);
  };

  const checkForNotMapped = (data, platform, configType) => {
    return (
      data?.[platform]?.filter(
        item =>
          +item?.status === 101 &&
          item?.configType?.toLowerCase() === configType
      )?.length > 0
    );
  };

  const verifyCrmForExportInSequence = async () => {
    const config = {
      url: URLS.checkCrmConnectionForExport,
      method: "GET"
    };
    const response = await makeApi(config);
    if (+response?.status === 200) {
      const respData = response?.data || {};
      const isHubspotConnected = "HUBSPOT" in respData;
      const isSfConnected = "SALESFORCE" in respData;
      const salesforceLeadNotMapped = checkForNotMapped(
        respData,
        "SALESFORCE",
        "lead"
      );
      const salesforceContactNotMapped = checkForNotMapped(
        respData,
        "SALESFORCE",
        "contact"
      );
      const hubspotContactNotMapped = checkForNotMapped(
        respData,
        "HUBSPOT",
        "contact"
      );
      sequenceContactStoreData.setHubspotExportStatus({
        ...sequenceContactStoreData.hubspotExportStatusExportStatus,
        hubspotContactNotMapped,
        isHubspotConnected
      });
      sequenceContactStoreData.setSfExportStatus({
        ...sequenceContactStoreData.sfExportStatus,
        salesforceLeadNotMapped,
        salesforceContactNotMapped,
        isSfConnected
      });
    }
  };

  const fetchUploadCountAndContactData = async interval => {
    try {
      const response = await sequenceContactStoreData.getContactUploadStatus(
        seqId
      );
      const trueJob =
        importProgressJobs?.totalCsvActiveJobs > 0 ||
        importProgressJobs?.totalCsvInProgressJobs > 0;

      if (trueJob) {
        setContactUploading("INPROGRESS");
      }
      if (
        isContactUploading &&
        ["INPROGRESS"].includes(isContactUploading?.toUpperCase())
      ) {
        await sequenceContactData.getSeqAnalyticsTab(seqId);
        getTableContacts("total", "", false);
      }
      const { status = "" } = response?.[0] || {};

      if (status?.toUpperCase() === "PROCESSED" || !status) {
        clearInterval(interval);
        setContactUploading(false);
        await sequenceContactData.getSeqAnalyticsTab(seqId);
        getTableContacts("total", "", false);
        return;
      }
    } catch (error) {
      clearInterval(interval);
    }
  };

  const calculateProcessingTime = (contactCount = 1) => {
    return contactCount > 0
      ? (10 + Math.floor(contactCount / 1000) * 4) * 1000
      : 0;
  };

  const handleHeadersResponse = response => {
    const responseWithName = response.filter(field => field.name !== "name");

    responseWithName.splice(0, 0, {
      name: "name",
      displayName: "Name",
      enabled: true,
      headerClassName: "nameWrapper"
    });
    setHeaders(
      responseWithName.map(response => {
        const customFieldLabel =
          settingsStoreData.customFields?.[response.name];
        return {
          ...response,
          displayName:
            response.name === "stage"
              ? "Status"
              : customFieldLabel || response.displayName
        };
      })
    );
  };

  const dragAndDropSaveCbk = async (newHeaderValues = []) => {
    tableConfigStore
      .editTableHeaders({
        tableName: "SEQUENCE_CONTACT",
        columns: newHeaderValues
      })
      .then(handleHeadersResponse);
  };

  //calls csv job function for every interval based on a boolean
  useEffect(() => {
    let interval;
    if (
      isContactUploading &&
      ["INPROGRESS", "IN_PROGRESS", "TO_BE_PROCESSED"].includes(
        isContactUploading?.toUpperCase()
      )
    ) {
      fetchUploadCountAndContactData(interval);
      interval = setInterval(
        () => fetchUploadCountAndContactData(interval),
        calculateProcessingTime(sequenceRenderState?.csvLength || 10)
      );
      return () => clearInterval(interval);
    }
  }, [isContactUploading]);

  // On mount, check if a job is already running (e.g. after page reload)
  useEffect(() => {
    const checkExistingJobs = async () => {
      const response = await sequenceContactStoreData.getContactUploadStatus(
        seqId
      );
      if (response?.length > 0) {
        const job = response[0];
        if (
          ["TO_BE_PROCESSED", "INPROGRESS"].includes(
            job.status?.toUpperCase()
          )
        ) {
          setContactUploading(job.status);
        }
      }
    };
    checkExistingJobs();
  }, []);

  useEffect(() => {
    if (selectedFilter) {
      setShowContactFilter(false);
      setSelectedFilter(true);
    }
  }, [selectedFilter]);

  useEffect(() => {
    if (!sequenceRenderState.performingSearch) {
      setLoader(true);
      resetValueToInitial();
      getTableContacts(sequenceRenderState.currentStage);
    }
  }, [
    sequenceRenderState.contactOwner.all,
    sequenceRenderState.contactOwner.idArr,
    contactLimit
  ]);

  useEffect(() => {
    setFilterArr(sequenceContactStoreData?.filteredList);
  }, [sequenceContactStoreData?.filteredList]);

  useEffect(() => {
    if (!isFromStepBadgeNavigation) {
      setLoader(true);
      resetValueToInitial();
      getTableContacts();
    }
    constructTeamDataInFilter();
    verifyCrmForExportInSequence();
    if (sequence) {
      Utils.mixpanelTrack(MP_EVENT.SQ_CT_VIEWED, {
        pageType: "Sequence Contacts",
        totalContacts: sequence?.contactsAdded,
        sequenceName: sequence?.name
      });
    }
    settingsStoreData.getCustomFields();
    tableConfigStore
      .getTableHeaders("SEQUENCE_CONTACT")
      .then(handleHeadersResponse);

    return () => {
      setSearchKeyword("");
      sequenceContactStoreData.setHubspotExportStatus({});
      sequenceContactStoreData.setSfExportStatus({});
      setFromStepBadgeNavigation(false);
      resetContactFilter();
      sequenceRenderState.setFilterByStep(null);
    };
  }, []);

  useEffect(() => {
    setHeaders(prev =>
      prev.map(field => {
        const customLabel = settingsStoreData.customFields?.[field.name];
        return customLabel ? { ...field, displayName: customLabel } : field;
      })
    );
  }, [settingsStoreData.customFields]);

  useEffect(() => {
    showStepsList && getTableContacts(sequenceRenderState?.currentStage);
  }, [showStepsList]);

  useEffect(() => {
    if (updateSequenceContacts) {
      setLoader(true);
      getTableContacts(sequenceRenderState.currentStage);
      setUpdateSequenceContacts(false);
    }
  }, [updateSequenceContacts]);

  useEffect(() => {
    if (sequenceStoreData.reloadSequenceContactPage) {
      reloadSequenceContactsPage();
      sequenceStoreData.setReloadSequenceContactPage(false);
    }
  }, [sequenceStoreData.reloadSequenceContactPage]);

  useEffect(() => {
    setSnContactUploading(pullContactState?.liJobStatus?.status);
  }, [pullContactState?.liJobStatus]);

  //Check for liJobStatus for calling at every interval
  useEffect(() => {
    let interval;
    if (pullContactState.liJobStatus && pullContactState.liJobStatus.status) {
      const snJobs = pullContactState?.liJobStatus.jobs;
      const totalContactsToImport = snJobs?.reduce(
        (acc, curr) =>
          acc + (curr?.job?.totalContacts - curr?.job?.noOfContactsImported),
        0
      );
      interval = setInterval(() => {
        try {
          pullContactState.getLiJobStatus(seqId);
        } catch (error) {
          console.console.error(
            "Error while fetching Active and In-progress job"
          );
        }
      }, calculateProcessingTime(totalContactsToImport || 10));
    }
    return () => clearInterval(interval);
  }, [pullContactState.liJobStatus]);

  //Total In progressjobs
  useEffect(() => {
    setTotalInprogressJobs(
      importProgressJobs?.totalCsvInProgressJobs +
        importProgressJobs?.totalLiInProgressJobs
    );
  }, [
    importProgressJobs?.totalCsvInProgressJobs,
    importProgressJobs?.totalLiInProgressJobs
  ]);

  //Total active jobs
  useEffect(() => {
    setTotalActiveBulkJobs(
      importProgressJobs?.totalCsvActiveJobs +
        importProgressJobs?.totalLiActiveJobs
    );
  }, [
    importProgressJobs?.totalCsvActiveJobs,
    importProgressJobs?.totalLiActiveJobs
  ]);

  useEffect(() => {
    if (
      importProgressJobs?.totalCsvActiveJobs +
        importProgressJobs?.totalCsvInProgressJobs +
        importProgressJobs?.totalLiActiveJobs +
        importProgressJobs?.totalLiInProgressJobs >
      0
    ) {
      const totalPercent = Utils.getWorkloadWeightedProgress(
        importProgressJobs?.csvImportJobs,
        importProgressJobs?.liImportJobs
      );
      setTotalProgressPercent(totalPercent);
    } else {
      setTotalProgressPercent(0);
    }
  }, [
    importProgressJobs?.csvImportJobs,
    importProgressJobs?.liImportJobs,
    importProgressJobs?.totalCsvActiveJobs,
    importProgressJobs?.totalCsvInProgressJobs,
    importProgressJobs?.totalLiActiveJobs,
    importProgressJobs?.totalLiInProgressJobs
  ]);

  return (
    <div
      className={`seqContactWrapper ${showStepsList ? "stepsListShown" : ""} ${
        showContactFilter ? "contactFilterShown" : ""
      }`}
    >
      <div
        className={`seq-contacts-section ${
          totalPages > 1 ? "" : "hidePagination"
        }`}
      >
        {/*
          Banner self-gates: renders nothing when DR feature is off OR when no
          contacts are awaiting approval. So we mount it unconditionally — it
          stays out of the way until there's actually something to act on.
        */}
        <AwaitingApprovalBanner sequenceId={seqId} />
        <SequenceContactsNav
          cbk={filterContactByStatus}
          seqId={seqId}
          currentTab={sequenceRenderState.currentStage}
          uploadedContactCbk={getUploadContact}
          addFilter={addFilter}
          metricData={metricData}
          setMetricData={setMetricData}
          getStepMetricData={getStepMetricData}
          getTotalCountForEachFilter={getTotalCountForEachFilter}
          preventLoader={["TO_BE_PROCESSED", "INPROGRESS"].includes(
            isContactUploading && isContactUploading?.toUpperCase()
          )}
        />
        <div
          className={`exportFilterSequenceSection ${
            totalContacts < 11 ? "hidePageLimitSpace" : ""
          }`}
        >
          {selectedEntityCount > 0 && !loader ? (
            <ContactSelectedCount
              selectedCount={selectedEntityCount}
              totalCount={totalContacts}
              loading={loader}
              allContactSelected={allContactSelected}
              setAllContactSelected={setAllContactSelected}
              resetCbk={resetContactCbk}
              selectAllCbk={selectAllCbk}
            />
          ) : (
            <SearchByContactKeyword
              searchContact={searchContact}
              searchKeyword={searchKeyword}
              submitForm={submitSearchByEmailInput}
              handleSearchAction={handleSearchAction}
              clearSearch={clearSearch}
              isEmailClose={isEmailClose}
            />
          )}
          <div className="tagSelectedSection">
            <ContactSelectedTagList />
          </div>
          <div className="filterExportBtnWrap">
            {totalContacts > 0 && (
              <>
                <PageLimit
                  limitPerPage={contactLimit}
                  text="Showing"
                  cbk={setContactLimit}
                  totalCount={totalContacts}
                />
                <AddToSequenceButton
                  selectedEntityCount={selectedEntityCount}
                  cbk={addToSequenceAction}
                  loading={loader}
                  checked={hasContactChecked()}
                  text="Add to Sequence"
                />
                <ExportBtn
                  selectedEntityCount={selectedEntityCount}
                  cbk={exportCbk}
                  allEntityCount={totalContacts}
                  checked={hasContactChecked()}
                  isExportEnabled={exportEnabled}
                  showExportTypeDropdown={showExportTypeDropdown}
                  setShowExportTypeDropdown={setShowExportTypeDropdown}
                  pageType="sequences"
                  text="Export"
                />
                {SequenceUtils.hasSteps(sequence) && (
                  <FilterByStep
                    setShowStepsList={setShowStepsList}
                    showStepsList={showStepsList}
                    resetContactCbk={resetContactCbk}
                  />
                )}
              </>
            )}
            <div className="filterWrapper">
              <div
                className="filterContactBtn"
                onClick={() => {
                  setShowContactFilter(!showContactFilter);
                  setShowStepsList(false);
                  resetContactCbk();
                }}
                onMouseOver={() => setShowTooltip(true)}
                onMouseLeave={() => setShowTooltip(false)}
              >
                <FilterIcon />
                {showTooltip && <CustomTooltip text="Filter by fields" />}
              </div>
            </div>
            <CustomDragAndDrop
              dataArr={headers.filter(
                field =>
                  field.name !== "owner" &&
                  field.name !== "action" &&
                  field.name !== "name"
              )}
              cbk={dragAndDropSaveCbk}
              saveLoader={tableConfigStore.editLoader === "SEQUENCE_CONTACT"}
            />
            <ContactMoreOption
              contactIds={contactIds}
              stage={sequenceRenderState?.currentStage}
              tableLoading={loader}
              resetContactCbk={reloadAndResetContact}
              contactCount={totalContacts}
              allContactSelected={allContactSelected}
              checked={hasContactChecked()}
              pageType={"sequence"}
              searchEmail={searchKeyword}
              sequenceId={seqId}
              activeTab={activeTab}
              selectedEntityCount={selectedEntityCount}
              retryContactCbk={retryContactCbk}
              bulkRemoveSeqContactCbk={bulkRemoveSeqContactCbk}
              bulkReactivateSeqContactCbk={bulkReactivateSeqContactCbk}
              bulkResumeSeqContactCbk={bulkResumeSeqContactCbk}
              bulkPauseSeqContactCbk={bulkPauseSeqContactCbk}
              addTagsCbk={addTagsCbk}
              removeTagsCbk={removeTagsCbk}
              sequenceToggleBtn={sequenceToggleBtn}
            />
          </div>
        </div>
        <div className="seq-contacts-table-section seqContactPage">
          <div
            className="tableWrapper"
            onScroll={Utils.handleStickyColumnInTable}
          >
            {(["TO_BE_PROCESSED", "INPROGRESS"].includes(
              isContactUploading && isContactUploading?.toUpperCase()
            ) ||
              isSnContactUploading) && (
              <LinearProgressLoader
                count={totalContacts}
                progress={totalProgressPercent}
                totalActiveBulkJobs={totalActiveBulkJobs}
                totalInProgressJobs={totalInProgressJobs}
              />
            )}
            <table>
              <thead>
                <tr>
                  {tableConfigStore.loading === "SEQUENCE_CONTACT" && (
                    <>
                      <th className="ctSelectAll placeholder">
                        <div>
                          <span className="linear-background"></span>
                        </div>
                      </th>
                      <th className="nameWrapper placeholder">
                        <div>
                          <span className="linear-background"></span>
                        </div>
                      </th>
                    </>
                  )}
                  {tableConfigStore.loading === "SEQUENCE_CONTACT" ? (
                    <>
                      {Array.from({ length: 20 }).map((header, idx) => (
                        <th
                          key={idx}
                          className="tableHeader"
                          style={{ minWidth: 80, height: 41 }}
                        >
                          <span className="linear-background"></span>
                        </th>
                      ))}
                    </>
                  ) : (
                    <>
                      {contactsData?.totalContacts > 0 && !loader && (
                        <th className="ctSelectAll">
                          <CheckBox
                            key="sequenceAllContactsCheck"
                            id="all"
                            checked={exportAllContactSelected}
                            cbk={markSelectedContact}
                            allContactsChecked={allContactSelected}
                          />
                        </th>
                      )}
                      {headers.map(header => {
                        const {
                          displayName,
                          name,
                          enabled,
                          headerClassName = ""
                        } = header;
                        return (
                          enabled && (
                            <th
                              key={name}
                              className={`tableHeader ${headerClassName}`.trim()}
                            >
                              <div>{displayName}</div>
                            </th>
                          )
                        );
                      })}
                      <th>
                        <div></div>
                      </th>
                    </>
                  )}
                </tr>
              </thead>
              <tbody className="contactContent">
                {(["TO_BE_PROCESSED", "INPROGRESS"].includes(
                  isContactUploading && isContactUploading?.toUpperCase()
                ) ||
                  isSnContactUploading) && (
                  <tr className="loaderPlaceholderRow">
                    <td
                      colSpan={headers?.filter(field => field.enabled).length}
                    ></td>
                  </tr>
                )}
                {loader ? (
                  <>
                    <ContactLoader
                      contactFields={(headers.length > 0
                        ? headers
                        : defaultFieldsForLoader
                      )
                        .concat([
                          {
                            displayName: "Actions",
                            name: "action",
                            key: "action",
                            enabled: true
                          }
                        ])
                        .map(header => {
                          return { key: header.name, enabled: header.enabled };
                        })}
                    />
                  </>
                ) : (
                  hasContacts() &&
                  contactsData?.individualSequenceAnalyticsList?.map(
                    (contact, index) => {
                      if (contact) {
                        const {
                          isSelected = false,
                          sequenceId = "",
                          contactId = "",
                          emailAddress = "",
                          emailInsights,
                          lastContacted = "",
                          status = "",
                          nextStep = 0,
                          nextEmailDate = "",
                          showNextDateTooltip = false,
                          nextTaskType = ""
                        } = contact;

                        return (
                          <tr
                            className="seq-contacts-table-body"
                            key={sequenceId}
                            id={sequenceId}
                            onClick={() => slideContactCard(contact)}
                            style={{ cursor: "pointer" }}
                          >
                            <td className="ctSelectAll" onClick={e => e.stopPropagation()}>
                              <CheckBox
                                key="autoBcc"
                                id={contactId}
                                checked={isSelected || false}
                                cbk={markSelectedContact}
                              />
                            </td>
                            {headers
                              .filter(header => header.enabled)
                              .map(header => {
                                switch (header.name) {
                                  case "name":
                                    return (
                                      <td
                                        key="name"
                                        className="nameWrapper contact-user-name"
                                      >
                                        <div>
                                          <h6
                                            className="triggerContactCard anchorHighLight"
                                            onClick={() =>
                                              slideContactCard(contact)
                                            }
                                          >
                                            {contact?.name || "--"}
                                          </h6>
                                        </div>
                                      </td>
                                    );
                                  case "email":
                                    return (
                                      <td key="email" className="ctUserEmail">
                                        <p
                                          className="triggerContactCard show-elipsis anchorHighLight"
                                          onClick={() =>
                                            slideContactCard(contact)
                                          }
                                        >
                                          {emailAddress}
                                        </p>
                                      </td>
                                    );
                                  case "stage":
                                    return (
                                      <td
                                        key="stage"
                                        className="contact-status"
                                        onClick={e => e.stopPropagation()}
                                      >
                                        <StatuSection
                                          contact={contact}
                                          {...props}
                                          viewEmailReply={viewEmailReply}
                                        />
                                        <OutofOotoInfoSection
                                          emailAddress={emailAddress}
                                          status={status}
                                          outofOotoTooltip={outofOotoTooltip}
                                          setOutofOotoTooltip={
                                            setOutofOotoTooltip
                                          }
                                          contact={contact}
                                          sequenceToggleBtn={sequenceToggleBtn}
                                          getFormattedDate={getFormattedDate}
                                        />
                                      </td>
                                    );
                                  case "insights":
                                    return (
                                      <td
                                        key="insights"
                                        className="contact-stage-insight"
                                      >
                                        <EmailInsightComponent
                                          emailInsight={emailInsights}
                                        />
                                      </td>
                                    );
                                  case "nextEmailDate":
                                    return (
                                      <td
                                        key="nextEmailDate"
                                        className="contact-insight-date"
                                      >
                                        {nextStep !== 0 &&
                                        status &&
                                        isEligibleToShowNextStep(status) &&
                                        nextEmailDate ? (
                                          <span
                                            className="stage-in"
                                            onMouseEnter={() =>
                                              getStageNextScheduledDateTooltip(
                                                contactId,
                                                true
                                              )
                                            }
                                            onMouseLeave={() =>
                                              getStageNextScheduledDateTooltip(
                                                contactId,
                                                false
                                              )
                                            }
                                            onClick={() =>
                                              navigateToOutBox(
                                                seqId,
                                                nextTaskType,
                                                emailAddress
                                              )
                                            }
                                          >
                                            {SequenceUtils.getNextScheduledEstimated(
                                              nextStep,
                                              nextEmailDate
                                            )}
                                            {showNextDateTooltip && (
                                              <CustomTooltip
                                                className={
                                                  index !== 0 ||
                                                  contactsData
                                                    ?.individualSequenceAnalyticsList
                                                    ?.length === 1
                                                    ? "topCenter"
                                                    : "bottomCenter"
                                                }
                                                text={`Step ${nextStep} is scheduled on ${DateUtils.getDateAndMonth(
                                                  nextEmailDate
                                                )} at ${DateUtils.getTimeByMerdian(
                                                  nextEmailDate
                                                )} (${DateUtils.getTimeZone(
                                                  nextEmailDate
                                                )})`}
                                              />
                                            )}
                                          </span>
                                        ) : (
                                          "--"
                                        )}
                                      </td>
                                    );
                                  case "lastContacted":
                                    return (
                                      <td
                                        key="lastContacted"
                                        className="contact-date"
                                      >
                                        {lastContacted !== null
                                          ? Utils.getDateFromString(
                                              lastContacted
                                            )
                                          : "--"}
                                      </td>
                                    );
                                  case "linkedinId":
                                    const linkedinUrl = contact.contact?.[header.name];
                                    return (
                                      <td
                                        key={header.name}
                                        className={header.headerClassName || ""}
                                        onClick={e => e.stopPropagation()}
                                      >
                                        {linkedinUrl ? (
                                          <p
                                            className="linkedin-wrapper"
                                            title={linkedinUrl}
                                          >
                                            <a
                                              href={
                                                linkedinUrl.startsWith("http")
                                                  ? linkedinUrl
                                                  : `https://${linkedinUrl}`
                                              }
                                              target="_blank"
                                              rel="noopener noreferrer"
                                              className="linkedin-link"
                                            >
                                              {linkedinUrl}
                                            </a>
                                          </p>
                                        ) : (
                                          "--"
                                        )}
                                      </td>
                                    );
                                  default:
                                    let value = "--";
                                    if (header.name.includes("customField")) {
                                      value =
                                        (contact.contact?.customFields &&
                                          contact.contact?.customFields[
                                            header.name
                                          ]) ||
                                        "--";
                                    } else {
                                      value =
                                        contact.contact?.[header.name] || "--";
                                    }
                                    return (
                                      <td
                                        key={header.name}
                                        className={header.name}
                                        title={value}
                                      >
                                        <p className="show-elipsis">{value}</p>
                                      </td>
                                    );
                                }
                              })}
                            <td onClick={e => e.stopPropagation()}>
                              <SequenceMoreOption
                                count={index}
                                contact={contact}
                                updateContact={setUpdateSequenceContacts}
                                seqId={seqId}
                                getTableContacts={getTableContacts}
                                activeTab={activeTab}
                              />
                            </td>
                          </tr>
                        );
                      }
                    }
                  )
                )}
              </tbody>
            </table>
          </div>

          {!loader &&
            !hasContacts() &&
            ((isContactUploading &&
              !["INPROGRESS", "IN_PROGRESS", "TO_BE_PROCESSED"].includes(
                isContactUploading?.toUpperCase()
              )) ||
              isContactUploading === null) && (
              <div className="add-contact-stage">
                {activeTab !== "total" && (
                  <>
                    <i className="material-icons-outlined">
                      supervisor_account
                    </i>
                    No Contacts Found
                  </>
                )}
                {showDemoVideoCard() && (
                  <>
                    <img src={NoContactImg} alt="" />
                    <h6>Add Contacts</h6>
                    <AddContactDropDown
                      addSingleContact={addSingleContact}
                      addBulkContact={addBulkContact}
                      showButton={true}
                      btnId="sequenceAddContactBtn"
                      allowContactsUpload={allowContactsUpload}
                      allowSequence={false}
                      sequence={sequence}
                      importFromContactsListClick={importFromContactsListClick}
                    />
                    <FeatureDemoVideo
                      name={"Add Contacts"}
                      linkText={"How to Add contacts in Sequence"}
                      type={"sequenceContacts"}
                    />
                  </>
                )}
              </div>
            )}
        </div>
        <PaginationComponent
          callback={paginate}
          loading={loader}
          totalPages={totalPages}
          currentPage={contactsData?.currentPage || 1}
        />
      </div>
      {showContactFilter && !showStepsList && (
        <SeqContactTeamDataFilterContext.Provider
          value={{
            defaultSelectAllTeamMemberObject,
            teamFilterDropDownData,
            setTeamFilterDropDownData,
            teamCount,
            setTeamCount
          }}
        >
          <SequenceContactFilter
            filterArr={filterArr}
            setFilterArr={setFilterArr}
            searchTerm={searchKeyword}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            limit={contactLimit}
            filterLoadingFn={setLoader}
            tableLoadingFn={setLoader}
            setContactFilter={setShowContactFilter}
            selectedFilter={selectedFilter}
            setSelectedFilter={setSelectedFilter}
            pageNo={contactsData?.currentPage || 1}
            seqId={seqId}
            isSharedSequenceWithUser={isSharedSequenceWithUser}
            showContactOwner={showContactOwner}
            defaultSelectAllTeamMemberObject={defaultSelectAllTeamMemberObject}
            data={data}
            setData={setData}
            activeFilter={activeFilter}
            setActiveFilter={setActiveFilter}
            resetAll={resetContactFilter}
          />
        </SeqContactTeamDataFilterContext.Provider>
      )}
      {showStepsList && (
        <StepsList
          seqId={seqId}
          getTableContacts={getTableContacts}
          clearSearch={clearSearch}
          addFilter={addFilter}
          metricData={metricData}
          setMetricData={setMetricData}
          getStepMetricData={getStepMetricData}
          analyticStepLoader={analyticStepLoader}
          setAnalyticStepLoader={setAnalyticStepLoader}
        />
      )}
    </div>
  );
};

const OutofOotoInfoSection = (props = {}) => {
  const {
    emailAddress = "",
    status = "",
    sequenceToggleBtn = false,
    outofOotoTooltip = false,
    setOutofOotoTooltip = () => {},
    getFormattedDate = () => {},
    contact = {}
  } = props || {};
  return (
    <>
      {status?.toUpperCase() === "PAUSED_OOTO" &&
        outofOotoTooltip === emailAddress && (
          <div className="outOfOfficeOverlay">
            <div className="leftContainer">
              <span className="outOfOfficeText">Out of Office</span>
              <div className="sequenceResumeText">
                {!sequenceToggleBtn
                  ? `This contact will not resume automatically since the sequence is disabled.`
                  : `This contact will auto-resume on ${getFormattedDate(
                      contact?.rescheduleDate
                    )}`}
              </div>
            </div>
            <img src={ootoCalendarIcon} alt="Out Of Office Calendar" />
          </div>
        )}
      {status === "PAUSED_OOTO" && (
        <i
          className="material-icons-outlined infoIcon"
          onMouseEnter={() => setOutofOotoTooltip(emailAddress)}
          onMouseLeave={() => setOutofOotoTooltip("")}
        >
          info
        </i>
      )}
    </>
  );
};

export default observer(SequenceContacts);
export { SequenceContacts, SeqContactTeamDataFilterContext };
